export default function isoDateToformattedDate(isoDate) {
  // converting Iso date to normal formatted date
  const dateObj = new Date(isoDate);
  const year = dateObj.getFullYear();
  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    dateObj
  );
  const day = dateObj.getDate();
  const formattedDate = `${day} ${month} ${year}`;
  return formattedDate;
}
